const candidateSubmissionConfig = {
    "candidateName" : "CSF01",
    "emailID":"CSF02",
    "contactNo":"CSF03",
    "totalExperience":"CSF04",
    "relevantExperience":"CSF05",
    "primarySkill":"CSF06",
    "clientsWorkedWith":"CSF07",
    "currentLocation":"CSF08",
    "noticePeriod":"CSF09",
    "candidateSynopsis":"CSF10",
    "currentCTC":"CSF11",
    "expectedCTC":"CSF12",
    "preferredLocation":"CSF13",
    "currenthourlyrate":"CSF14",
    "currentdailyrate":"CSF15",
    "currentmonthlyrate":"CSF16",
    "currentyearlyrate":"CSF17",
    "expectedhourlyrate":"CSF18",
    "expecteddailyrate":"CSF19",
    "expectedmonthlyrate":"CSF20",
    "expectedyearlyrate":"CSF21",
}
    
export default candidateSubmissionConfig;